import {styled} from '../../../utils';

export default styled('footer')({
  boxSizing: 'border-box',
  flexShrink: 0
});



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/Footer.tsx